/* RR Wishlist — lightweight, no-app wishlist saved to the shopper's browser.
   Hearts on product cards + a wishlist page. Storage: localStorage array of handles. */
(function () {
  var KEY = 'rr_wishlist_v1';
  var HEART = '<svg class="rr-heart-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function toggle(handle) {
    var list = read(), i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    write(list);
    return i === -1; // true if now saved
  }
  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function money(cents) {
    try { if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents); } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  function syncHearts() {
    var saved = read();
    document.querySelectorAll('.rr-heart').forEach(function (btn) {
      var on = saved.indexOf(btn.getAttribute('data-handle')) !== -1;
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function syncCount() {
    var n = read().length;
    document.querySelectorAll('.rr-wishlist-count').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }

  function injectHeaderIcon() {
    var ul = document.querySelector('.shopping__cart-links');
    if (!ul || ul.querySelector('.rr-header-wishlist-li')) return;
    var li = document.createElement('li');
    li.className = 'rr-header-wishlist-li';
    li.innerHTML = '<a class="rr-header-wishlist" href="/pages/wishlist" aria-label="Wishlist">' + HEART + '<span class="rr-wishlist-count is-empty">0</span></a>';
    var cart = ul.querySelector('.cart-links__link-cart');
    if (cart) { ul.insertBefore(li, cart); } else { ul.appendChild(li); }
  }

  function renderPage() {
    var root = document.getElementById('rr-wishlist-root');
    if (!root) return;
    var handles = read();
    if (!handles.length) {
      var msg = root.getAttribute('data-empty') || 'Your wishlist is empty.';
      root.innerHTML = '<p class="rr-wl-empty">' + msg + '</p>';
      return;
    }
    root.innerHTML = '<div class="rr-wl-grid"></div>';
    var grid = root.querySelector('.rr-wl-grid');
    // preserve order; build placeholders so order is stable while fetching
    handles.forEach(function (handle) {
      var card = document.createElement('div');
      card.className = 'rr-wl-card';
      card.setAttribute('data-handle', handle);
      grid.appendChild(card);
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) { card.remove(); return; }
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var title = (p.title || '').replace(/</g, '&lt;');
          card.innerHTML =
            '<button class="rr-heart is-saved rr-wl-remove" data-handle="' + handle + '" aria-label="Remove from wishlist">' + HEART + '</button>' +
            '<a class="rr-wl-img" href="/products/' + handle + '">' + (img ? '<img src="' + sized(img, 600) + '" alt="' + title + '" loading="lazy">' : '') + '</a>' +
            '<a class="rr-wl-title" href="/products/' + handle + '">' + title + '</a>' +
            '<div class="rr-wl-price">' + money(p.price) + '</div>' +
            '<a class="rr-wl-btn" href="/products/' + handle + '">View</a>';
        })
        .catch(function () { card.remove(); });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.rr-heart');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    var nowSaved = toggle(handle);
    btn.classList.toggle('is-saved', nowSaved);
    btn.setAttribute('aria-pressed', nowSaved ? 'true' : 'false');
    btn.classList.remove('rr-pop'); void btn.offsetWidth; btn.classList.add('rr-pop');
    syncCount();
    if (document.getElementById('rr-wishlist-root')) renderPage();
  });

  document.addEventListener('DOMContentLoaded', function () {
    injectHeaderIcon();
    syncHearts();
    syncCount();
    renderPage();
  });
})();
